export default __webpack_public_path__ + "static/ITGuyShort-e8c4dbe8bf2bdc5ca8427a8f39ce1c62.mp4";